import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from './EmblaCarouselArrowButtons';

const tiles = (): void => {
  const selectors = {
    tilesSection: '[data-tiles]',
    tilesCarouselViewport: '[data-tiles-carousel-viewport]',
    tilesCarouselPrev: '[data-tiles-carousel-prev]',
    tilesCarouselNext: '[data-tiles-carousel-next]',
  };

  const tilesSections = document.querySelectorAll(selectors.tilesSection);

  tilesSections.forEach((section) => {
    const viewportNode: any = section.querySelector(
      selectors.tilesCarouselViewport
    );
    const prevBtnNode: any = section.querySelector(selectors.tilesCarouselPrev);
    const nextBtnNode: any = section.querySelector(selectors.tilesCarouselNext);

    const options: EmblaOptionsType = {
      loop: false,
      align: 'start',
    };

    const embla = EmblaCarousel(viewportNode, options);

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
      embla,
      prevBtnNode,
      nextBtnNode
    );
  });
};

export default tiles;
